import { useEffect } from 'react';
import useTermStore from '../store/cmsStore/termStore';
import Seo from '../components/Seo';


const Term = () => {
  const {staticpage,fetchStaticPageContent } = useTermStore();
 

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchStaticPageContent(2);
  }, [fetchStaticPageContent]);



  return (
<>
        <Seo
          title="Terms of Service | Sammmm User Agreement & Website Policies"
          description="Read Sammmm's Terms of Service to understand your rights, responsibilities, account usage, purchases, refunds, and policies for using our website and services."
        />
{staticpage.content && (
    <div className="mb-0" dangerouslySetInnerHTML={{ __html: staticpage.content }}></div>

)}
</>
);
};


export default Term;